import { Head, Link } from '@inertiajs/react'

interface Workspace {
  id: number
  name: string
  slug: string
  role: string
}

interface IndexProps {
  workspaces: Workspace[]
}

export default function Index({ workspaces }: IndexProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Head title="Workspaces" />

      <nav className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            <h1 className="text-xl font-bold text-gray-900">Doqubase</h1>
            <Link
              href="/session"
              method="delete"
              as="button"
              className="rounded-md bg-gray-100 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200"
            >
              Log out
            </Link>
          </div>
        </div>
      </nav>

      <main className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold text-gray-900">Your Workspaces</h2>
          <Link
            href="/workspaces/new"
            className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-700"
          >
            New Workspace
          </Link>
        </div>

        {workspaces.length === 0 ? (
          <div className="mt-12 text-center">
            <p className="text-lg text-gray-500">You don&apos;t have any workspaces yet.</p>
            <p className="mt-2 text-sm text-gray-400">
              Create your first workspace to get started.
            </p>
          </div>
        ) : (
          <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {workspaces.map((workspace) => (
              <Link
                key={workspace.id}
                href={`/${workspace.slug}`}
                className="block rounded-lg border border-gray-200 bg-white p-6 shadow-sm transition hover:shadow-md"
              >
                <h3 className="text-lg font-semibold text-gray-900">{workspace.name}</h3>
                <span className="mt-2 inline-block rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600">
                  {workspace.role}
                </span>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  )
}
